/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersWithoutSupplierData } from '../../models/members-without-supplier-data';

export interface MemberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch$Params {
  orgId: string;
  action: 'suspend' | 'delete' | 'activate';
  org: string;
}

export function memberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch(http: HttpClient, rootUrl: string, params: MemberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
  const rb = new RequestBuilder(rootUrl, memberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch.PATH, 'patch');
  if (params) {
    rb.path('orgId', params.orgId, {});
    rb.query('action', params.action, {});
    rb.query('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersWithoutSupplierData>;
    })
  );
}

memberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch.PATH = '/api/v2/secretariat/members/{orgId}/status';
